export enum ActionType {
  // creatte user
  SEND_HIGH_STRESS_NOTIFICATION = "action/SEND_HIGH_STRESS_NOTIFICATION",
  SEND_HIGH_STRESS_NOTIFICATION_SUCCESS = "action/SEND_HIGH_STRESS_NOTIFICATION_SUCCESS",
  SEND_HIGH_STRESS_NOTIFICATION_ERROR = "action/SEND_HIGH_STRESS_NOTIFICATION_ERROR",
  RESET_SEND_HIGH_STRESS_NOTIFICATION = "action/RESET_SEND_HIGH_STRESS_NOTIFICATION",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface SendHighStressNotificationData {
  user_ids?: string;
  short_text: string;
  notification_text: string;
}
